import { render, staticRenderFns } from "./classHourRecord.vue?vue&type=template&id=c60dc4c8&"
import script from "./classHourRecord.vue?vue&type=script&lang=js&"
export * from "./classHourRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports